import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const TraficoUs = ({ fechas, items }) => {
    const [apexd, setApexd] = useState([
        {
            name: 'Descarga',
            data: [],
        },
        {
            name: 'Subida',
            data: [],
        },
    ]);
    const apexOpts = {
        responsive: [
            {
                breakpoint: 480, // Establece el ancho máximo del contenedor
                options: {
                    chart: {
                        height: 300, // Ajusta la altura del gráfico para dispositivos más pequeños
                    },
                },
            },
            // Puedes añadir más breakpoints con diferentes opciones si es necesario
        ],
        chart: {
            height: 327,
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '45%',
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 3,
            colors: ['transparent'],
        },
        colors: ['#db3333', '#2782e4'],
        xaxis: {
            categories: fechas,
            labels: {
                show: true,
                rotate: 90,
                position: 'top',
            },
        },
        legend: {
            offsetY: 7,
        },
        yaxis: {
            title: {
                text: 'GiB',
            },
        },

        fill: {
            opacity: 1,
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2,
            },
            borderColor: '#f1f3fa',
            padding: {
                bottom: 5,
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + 'GB';
                },
            },
        },
    };

    useEffect(() => {
        if (items) setApexd(items);
    }, [items]);
    return (
        <div style={{ height: '327px' }} className="mt-3 chartjs-chart">
            <Chart options={apexOpts} series={apexd} type="bar" height={327} className="apex-charts" />
        </div>
    );
};

export default TraficoUs;
